/**
 * Firestore rejects `undefined` field values — drop them before write.
 *
 * Shared by the global (non org-scoped) Firestore services that hand-wire their
 * own CRUD. `OrgScopedCrudService` / `ChildCrudService` do this internally.
 */
export function stripUndefined(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined));
}
//# sourceMappingURL=stripUndefined.js.map